module.exports = __webpack_public_path__ + "static/media/kecko.2bff7cdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kecko.png
// module id = 1019
// module chunks = 0